<template>
  <b-modal
    id="college-event-details-modal"
    ref="modal"
    class="large-modal"
    size="lg"
  >
    <template v-if="workshop">
      <template>
        <div class="upper">
          <label>Workshop Details</label>
          <div class="new-title">
            {{ workshop.topic }}
          </div>
        </div>
      </template>

      <p v-if="workshop.endsOnDifferentDay" class="date">
        {{ workshop.start_time | format('MMMM Do hh:mm A') }} - {{ workshop.end_time | format('MMMM Do h:mm A') }}
      </p>
      <p v-else class="date">
        {{ workshop.start_time | format('MMMM Do hh:mm A') }} - {{ workshop.end_time | format('h:mm A') }}
      </p>

      <p v-if="workshop.host">
        Host: {{ workshop.host.first_name }} {{ workshop.host.last_name }}
      </p>

      <p>
        Location: Online
      </p>

      <ul class="pills">
        <li v-if="workshop.joined">
          Joined!
        </li>
        <li v-else-if="workshop.num_spots_left === 1">
          {{ workshop.num_spots_left }} Spot Left!
        </li>
        <li v-else>
          {{ workshop.num_spots_left }} Spots Left!
        </li>
      </ul>

      <div v-if="workshop.description">
        <hr>
        <b class="d-block mt-2 mb-2">Description</b>
        <p class="description">
          {{ workshop.description }}
        </p>
      </div>

      <div v-if="workshop.struggle_areas.length">
        <hr>
        <b class="d-block mt-2 mb-2">Topics:</b>
        <ul
          class="table bm-table"
        >
          <li v-for="struggle in workshop.struggle_areas" :key="struggle.id">
            {{ struggle.name }}
          </li>
        </ul>
      </div>

      <hr>
      <template v-if="!workshop.joined">
        <h6>
          Workshop Cost -
          <span v-if="!workshop.cost">FREE</span>
          <span v-if="auto_pay_with_credit && credits">1 Wellbeing Workshop Credit</span>
          <span v-else>{{ workshop.cost/100 | currency }}</span>
        </h6>
      </template>
      <template slot="modal-footer">
        <button class="btn" type="button" @click="hide()">
          Dismiss
        </button>
        <button
          v-if="!workshop.joined && workshop.canJoin && $store.getters.currentUser.isStudent"
          class="btn btn--primary"
          type="button"
          :disabled="saving"
          @click="$emit('register', { workshop, auto_pay_with_credit })"
        >
          <font-awesome-icon
            v-if="saving"
            :spin="true"
            :icon="['fas', 'spinner']"
            class="icon alt"
          />
          <span v-else>Reserve My Spot</span>
        </button>

        <button
          v-if="workshop.joined && sessionInTheFuture"
          class="btn"
          type="button"
          :disabled="saving"
          @click="$emit('withdraw', workshop)"
        >
          <font-awesome-icon
            v-if="saving"
            :spin="true"
            :icon="['fas', 'spinner']"
            class="icon alt"
          />
          <span v-else>Withdraw from Workshop</span>
        </button>
      </template>
    </template>
  </b-modal>
</template>

<script>
import StudentClient from '@/api/StudentClient';
import WorkshopClient from '@/api/WorkshopClient';
import moment from 'moment';

export default {
  name: 'WorkshopViewModal',
  data() {
    return {
      studentClient: new StudentClient(this.$http),
      workshopClient: new WorkshopClient(this.$http),
      saving: false,
      auto_pay_with_credit: true,
      credits: 0,
      workshop: null,
    };
  },
  computed: {
    sessionInTheFuture() {
      if (!this.workshop.start_time) {
        return false
      }
      return this.workshop.start_time
        && moment(this.workshop.start_time).diff(moment(), 'minutes') > 0;
    }
  },
  async mounted() {
    const credits = await this.studentClient.getRemainingCredits();
    this.credits = credits.group_session_credits_remaining || 0;
  },
  methods: {
    show(workshop) {
      this.saving = false;
      this.workshop = workshop;
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
  },
};
</script>

<style lang="scss" scoped>
#college-event-details-modal {
  .upper {
    display: block;
    position: relative;
    padding-right: 30px;
  }

  label {
    @include label;

    display: block;
    margin-bottom: 10px;
  }

  .date {
    font-size: 18px;
    color: rgba(white, 0.75);
  }

  .pills {
    margin-top: 20px;
  }

  .new-title {
    display: block;
    color: white;
    font-size: 30px;
    font-weight: 700;
    font-family: "Playfair Display", serif;
    line-height: 1;
    text-transform: capitalize;
  }

  .description {
    opacity: 0.76;
    word-wrap: break-word;
  }

  h6 {
    font-weight: normal !important;
    font-size: 25px;
    margin-top: 30px;
    margin-bottom: 10px;

    span {
      font-weight: bold !important;
    }
  }

  .green {
    font-size: 13px;
    color: $green;
  }

  .text-btn {
    border: none;
    background: none;
    color: $red;
    padding: 0;
    outline: none;
    height: auto;
    font-weight: normal;
    margin-top: 25px;
    text-align: right;
    text-transform: none;
    opacity: 0.75;

    &:hover,
    &:focus {
      opacity: 1;
      text-decoration: underline;
    }
  }
}
</style>
